module.exports = __webpack_public_path__ + "img/认证.72632741.png";